<script setup>
import { computed, ref, onMounted } from "vue";
import { t } from "@/controllerLK/GlobusLocalization";
import ProjectModalControl from "./ProjectModalControl.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  isEdit: {
    type: Boolean,
    default: false
  },
  isArchive: {
    type: Boolean,
    default: false
  },
  nameAlert: {
    type: String,
    default: ""
  }
});

const emit = defineEmits([
  "update:modelValue",
  "close",
  "showDeleteProjectModal",
  "toggleAccessList",
  "toggleProjectHistory"
]);

const inputNameRef = ref(null);

onMounted(() => {
  if (inputNameRef.value) {
    inputNameRef.value.focus();
  }
});

const formData = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val)
});

const updateField = (field, value) => {
  emit("update:modelValue", { ...props.modelValue, [field]: value });
};

defineExpose({
  focus: () => inputNameRef.value?.focus()
});
</script>

<template>
  <div class="project-main-tab">
    <ProjectModalControl
      :is-archive-page="props.isArchive"
      :is-archive="formData.is_archive"
      :is-edit="props.isEdit"
      :is-owner="formData.is_owner"
      @close-project-modal="emit('close')"
      @show-delete-project-modal="emit('showDeleteProjectModal')"
      @update:is-archive="val => updateField('is_archive', val)"
      @toggle-access-list="emit('toggleAccessList')"
      @toggle-project-history="emit('toggleProjectHistory')"
    />

    <InputSecondary
      ref="inputNameRef"
      :model-value="formData.name"
      :error="nameAlert.length > 0"
      :alert="nameAlert"
      size="large"
      :placeholder="t('project_modal_name.placeholder.name')"
      @update:model-value="val => updateField('name', val)"
    />

    <TextAreaSecondary
      :model-value="formData.description"
      height="100%"
      class="project-main-tab__description"
      :placeholder="t('project_modal_name.placeholder.description')"
      @update:model-value="val => updateField('description', val)"
    />
  </div>
</template>

<style lang="scss" scoped>
.project-main-tab {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20px;

  &__description {
    height: 100%;
  }
}
</style>